import styled from "styled-components";
import { dark } from "../constants/styles";

// Inline banner used for form-wide notices: warning when an account is
// unconfirmed, danger for locked accounts, info for success flash messages.
// Has an optional action slot on the right (a button or link).
//
// Props: variant = 'info' | 'warning' | 'danger' | 'success'
const COLORS = {
  info: { bg: "#eff6ff", border: "#bfdbfe", text: "#1e40af" },
  warning: { bg: "#fff7ed", border: "#fed7aa", text: "#9a3412" },
  danger: { bg: "#fef2f2", border: "#fecaca", text: "#991b1b" },
  success: { bg: "#f0fdf4", border: "#bbf7d0", text: "#166534" },
};

const Wrap = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  background: ${({ $variant }) => COLORS[$variant].bg};
  border: 1px solid ${({ $variant }) => COLORS[$variant].border};
  color: ${({ $variant }) => COLORS[$variant].text};
  font-size: 13px;
  line-height: 1.5;

  [data-theme="dark"] & {
    background: rgba(255, 255, 255, 0.04);
    border-color: ${dark.border};
  }
`;

const Icon = styled.span`
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
`;

const Body = styled.div`
  flex: 1 1 auto;

  & strong {
    font-weight: 700;
  }
`;

const Action = styled.div`
  flex: 0 0 auto;
  margin-left: 8px;
`;

const GLYPH = {
  info: "ⓘ",
  warning: "⚠",
  danger: "⛔",
  success: "✓",
};

export default function InlineAlert({
  variant = "info",
  title,
  children,
  action,
  role = "status",
}) {
  return (
    <Wrap
      $variant={variant}
      role={role}
      aria-live={variant === "danger" ? "assertive" : "polite"}
    >
      <Icon aria-hidden="true">{GLYPH[variant]}</Icon>
      <Body>
        {title && (
          <div>
            <strong>{title}</strong>
          </div>
        )}
        {children}
      </Body>
      {action && <Action>{action}</Action>}
    </Wrap>
  );
}
